export const CHART_COLORS = [
  'oklch(0.543 0.079 202.97)',
  'oklch(0.735 0.11 83.73)',
  'oklch(0.63 0.1 38.04)',
  'oklch(0.473 0.075 37.88)',
  'oklch(0.42 0.019 352.83)',
  'oklch(0.443 0.079 202.97)',
  'oklch(0.635 0.11 83.73)',
  'oklch(0.53 0.1 38.04)',
  'oklch(0.373 0.075 37.88)',
  'oklch(0.32 0.019 352.83)',
  'oklch(0.663 0.079 202.97)',
  'oklch(0.835 0.09 83.73)',
  'oklch(0.75 0.09 38.04)',
  'oklch(0.593 0.075 37.88)',
  'oklch(0.54 0.025 352.83)',
] as const

export type ChartColor = (typeof CHART_COLORS)[number]

export const colorAtIndex = (i: number): ChartColor =>
  CHART_COLORS[i % CHART_COLORS.length]

/** Light background wash of a chart color, for surfaces tied to a series (e.g. emphasised table rows). */
export const chartColorWash = (i: number, percent = 8): string =>
  `color-mix(in srgb, ${colorAtIndex(i)} ${percent}%, transparent)`

export const AXIS_PROPS = {
  stroke: 'var(--gray-6)',
  tick: { fill: 'var(--gray-9)', fontSize: 14 },
  tickLine: false,
  axisLine: false,
} as const

export const CHART = {
  strokeWidth: 1.5,
  gridStroke: 'var(--gray-3)',
  gridDash: '3 6',
  axisStroke: 'var(--gray-6)',
  tickFill: 'var(--gray-9)',
  tickFontSize: 14,
  areaFillOpacity: 0.08,
  barFillOpacity: 0.7,
  pieFillOpacity: 0.85,
  animationDuration: 600,
  animationEasing: 'ease-out' as const,
  margin: { top: 8, right: 4, bottom: 0, left: -12 },
  cursorStroke: 'var(--gray-6)',
  cursorDash: '3 3',
} as const
